/**
 * /belanja layout — nested Stack untuk tab Belanja (plan 19 Fase 1).
 *
 * Pola sama dengan akun/_layout.tsx + library/_layout.tsx: tanpa layout ini,
 * sub-screen belanja/* (top-up, transaksi) bocor ke tab bar sebagai tab
 * duplikat tanpa label.
 */

import { Stack } from 'expo-router';

export default function BelanjaLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: 'fade',
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="top-up" />
      <Stack.Screen name="transaksi" />
    </Stack>
  );
}
